exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.kds[data-v-61e8d552] {\n  font-size: 14px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.71;\n  letter-spacing: 0.15px;\n  color: #000000;\n}\n@media only screen and (min-width: 1264px) {\n.container[data-v-61e8d552] {\n    max-width: 1450px;\n}\n}\n", ""]);

